import React from "react";
import { ConvertDateToJalali } from "utils/ConvertDateToJalali";
import { SubstractMonth } from "utils/SubstractMonth";

const useSetFromDateUI = (IsRange, IsFromDate, SetOutput) => {
  React.useEffect(() => {
    if (IsRange) {
      if (IsFromDate) {
        SetOutput((prev) => ({
          ...prev,
          fromDate: ConvertDateToJalali(SubstractMonth()),
        }));
      }
    }
  }, []);
};

export default useSetFromDateUI;
